import styled from '@emotion/styled';
import RecordLoadingIcon from '@/public/icons/record/recordSaveLoading.svg';

const Container = styled.div<{ isRecording?: boolean; disabled?: boolean }>`
  border-radius: 12px;
  border: 1px solid var(--dk-bg, #fff);
  background: ${({ isRecording, disabled }) =>
    disabled ? 'var(--dk-bg-subtle, #F9FAFB)' : isRecording ? 'rgba(199, 122, 196, 0.12)' : 'var(--dk-bg, white)'};

  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.12),
    0px 16px 32px 0px rgba(0, 0, 0, 0.12),
    0px 0px 4px 0px rgba(0, 0, 0, 0.08) inset;
  backdrop-filter: blur(12px);
  width: fit-content;
  transition: background 0.2s ease-in-out;
`;

const SvgBoxButton = styled.button`
  display: flex;
  width: 36px;
  height: 36px;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  font-size: 12px;
  word-break: keep-all;

  :hover {
    background: rgba(199, 122, 196, 0.08);
  }
  :active {
    background: rgba(199, 122, 196, 0.16);
  }
  :disabled {
    background: none;
    cursor: default;
  }
`;

const StyledTimer = styled.div`
  color: #c77ac4;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  flex-grow: 1;
  width: 121px;
  padding-left: 4px;
  padding-right: 4px;
`;

const RecordingContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const StyledText = styled.div`
  color: #c77ac4;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  white-space: nowrap;
`;

const SpinnerLayout = styled.div`
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledTopLayout = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const SpinningIcon = styled(RecordLoadingIcon)`
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export {
  Container,
  SvgBoxButton,
  StyledTimer,
  RecordingContainer,
  StyledText,
  SpinnerLayout,
  StyledTopLayout,
  SpinningIcon,
};
